import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardDriver = _resolveComponent("DashboardDriver")!
  const _component_DashboardModera = _resolveComponent("DashboardModera")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user && _ctx.user?.role_id == 4)
      ? (_openBlock(), _createBlock(_component_DashboardDriver, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.user && _ctx.user?.role_id == 3)
      ? (_openBlock(), _createBlock(_component_DashboardModera, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}